import { Box, Typography } from '@mui/material'
import React from 'react'
import logoMsamp from "../../assets/logo_msanp.jpg"
import logoPresidence from "../../assets/presidence.png"
import photoMsanp from "../../assets/photo_msanp.png"
import { grey } from '@mui/material/colors'
function ChartMsanp() {
  return (
    <Box sx={{bgcolor:grey[300],display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
        <img src={logoMsamp} width={125} height={90} />
        <img src={logoPresidence} width={180} height={90} />
        <img src={photoMsanp} width={400} height={90} sx={{mr:5}} />
    </Box>
  )
}

export default ChartMsanp